import { render, staticRenderFns } from "./assign-to-user-form.vue?vue&type=template&id=5ebbe1b1&scoped=true&"
import script from "./assign-to-user-form.vue?vue&type=script&lang=js&"
export * from "./assign-to-user-form.vue?vue&type=script&lang=js&"
import style0 from "./assign-to-user-form.vue?vue&type=style&index=0&id=5ebbe1b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebbe1b1",
  null
  
)

export default component.exports